import * as React from 'react';
import { Skeleton } from 'shared/components/Skeleton';

const FormUploaderPlaceholder: React.FC = () => (
  <Skeleton width="100%" height="64px" />
);

export { FormUploaderPlaceholder };
